/* Radio install promotion policy. Product choices, not browser requirements. */
((root) => {
  'use strict';
  const DAY = 86400000;
  const clean = (value = {}) => ({
    count: Math.max(0, Math.min(3, Number(value.count) || 0)),
    last: Math.max(0, Number(value.last) || 0),
    installed: value.installed === true,
    never: value.never === true,
    days: Array.isArray(value.days) ? [...new Set(value.days.filter(x => /^\d{4}-\d{2}-\d{2}$/.test(x)))].slice(-30) : [],
    daysAtLast: Math.max(0, Number(value.daysAtLast) || 0)
  });
  const eligible = ({ saved, listening, visible, radio, installed, supported, blocked, sessionShown, storage }) => {
    const s = clean(saved);
    if (!storage || !radio || !visible || installed || s.installed || s.never || !supported || blocked || sessionShown || listening < 180000 || s.count >= 3) return false;
    if (!s.count) return true;
    const delay = (s.count === 1 ? 14 : 30) * DAY;
    return Date.now() - s.last >= delay && s.days.filter(day => day > new Date(s.last).toLocaleDateString('sv-SE')).length >= 2;
  };
  const api = { clean, eligible };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.AsIfRadioInstallPolicy = Object.freeze(api);
})(typeof window !== 'undefined' ? window : globalThis);
